/* ============================================================
   EverSirius UK — Theme JavaScript
   Handles: VAT toggle, cart drawer (Shopify AJAX API),
            product gallery thumbs, quantity stepper, accordion
   ============================================================ */

(function () {
  'use strict';

  /* ---- Mobile Nav ----------------------------------------- */
  function toggleMobileNav() {
    var nav     = document.getElementById('es-mobile-nav');
    var overlay = document.getElementById('es-mobile-overlay');
    var burger  = document.getElementById('es-hamburger');
    var open    = nav && nav.classList.contains('open');
    if (open) {
      closeMobileNav();
    } else {
      if (nav)     nav.classList.add('open');
      if (overlay) overlay.classList.add('open');
      if (burger)  burger.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileNav() {
    var nav     = document.getElementById('es-mobile-nav');
    var overlay = document.getElementById('es-mobile-overlay');
    var burger  = document.getElementById('es-hamburger');
    if (nav)     nav.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    if (burger)  burger.classList.remove('open');
    document.body.style.overflow = '';
  }

  window.toggleMobileNav = toggleMobileNav;
  window.closeMobileNav  = closeMobileNav;

  /* ---- VAT Toggle ----------------------------------------- */
  var VAT_RATE = window.esVatRate || 0.20;

  function toggleVAT(checked) {
    document.body.classList.toggle('show-inc', checked);

    // Update all prod-price-sub labels
    document.querySelectorAll('.prod-price-sub').forEach(function (el) {
      el.textContent = checked ? 'inc VAT' : 'ex VAT';
    });
  }

  window.toggleVAT = function (checkbox) {
    toggleVAT(checkbox.checked);
  };

  // Sync any duplicate VAT toggles on the page
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('es-vat-input')) {
      var checked = e.target.checked;
      document.querySelectorAll('.es-vat-input').forEach(function (inp) {
        inp.checked = checked;
      });
      toggleVAT(checked);
    }
  });

  /* ---- Cart Drawer (Shopify AJAX Cart API) ----------------- */
  var cartOverlay = null;
  var cartDrawer = null;

  function getEl(id) { return document.getElementById(id); }

  function openCart() {
    cartOverlay = cartOverlay || document.querySelector('.cart-overlay');
    cartDrawer = cartDrawer || document.querySelector('.cart-drawer');
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  window.openCart = openCart;
  window.closeCart = closeCart;

  // Close on overlay click
  document.addEventListener('click', function (e) {
    if (e.target && e.target.classList.contains('cart-overlay')) {
      closeCart();
    }
  });

  function fetchJsonSafe(url, options) {
    return fetch(url, options)
      .then(function (r) {
        if (!r.ok) return null;
        return r.text().then(function (text) {
          if (!text) return null;
          try { return JSON.parse(text); } catch (e) { return null; }
        });
      })
      .catch(function () { return null; });
  }

  function fetchCart() {
    return fetchJsonSafe('/cart.js', { headers: { 'Content-Type': 'application/json' } });
  }

  function addToCart(variantId, qty, callback) {
    fetchJsonSafe('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (result) {
        if (result === null) return;
        refreshCart();
        openCart();
        if (callback) callback();
      });
  }

  function changeCartQty(key, delta) {
    fetchCart().then(function (cart) {
      if (!cart) return;
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item) return;
      var newQty = item.quantity + delta;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function () { refreshCart(); });
    });
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function () { refreshCart(); });
  }

  window.changeCartQty = changeCartQty;
  window.removeCartItem = removeCartItem;

  function fmtMoney(cents) {
    return '£' + (cents / 100).toFixed(2).replace('.00', '');
  }

  function refreshCart() {
    fetchCart().then(function (cart) {
      if (!cart) return;
      renderCartDrawer(cart);
      updateCartBadge(cart.item_count);
    });
  }

  function renderCartDrawer(cart) {
    var itemsEl = getEl('es-cart-items');
    var emptyEl = getEl('es-cart-empty');
    var subtotalEl = getEl('es-cart-subtotal');
    var shipEl = getEl('es-cart-ship');
    var totalEl = getEl('es-cart-total');
    var fillEl = getEl('es-free-ship-fill');
    var labelEl = getEl('es-free-ship-label');

    if (!itemsEl) return;

    var FREE_SHIP_THRESHOLD = 15000; // £150 in pence
    var SHIP_COST = 695; // £6.95

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = 'flex';
      itemsEl.innerHTML = '';
      if (emptyEl) itemsEl.appendChild(emptyEl);
      if (subtotalEl) subtotalEl.textContent = '£0';
      var vatEl = getEl('es-cart-vat');
      if (vatEl) vatEl.textContent = '£0';
      if (totalEl) totalEl.textContent = '£0';
      if (shipEl) shipEl.textContent = 'Calculated at checkout';
      if (fillEl) fillEl.style.width = '0%';
      if (labelEl) labelEl.textContent = 'Spend £150 for free UK delivery';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.featured_image ? item.featured_image.url : '';
      var safeName = item.title.replace(/'/g, '\\\'');
      var safeKey = item.key;

      html += '<div class="cart-item">';
      if (imgSrc) {
        html += '<img class="cart-item-img" src="' + imgSrc + '" alt="' + item.title + '">';
      } else {
        html += '<div class="cart-item-img" style="background:#edeae3"></div>';
      }
      html += '<div>';
      html += '<p class="cart-item-name">' + item.product_title + '</p>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="cart-item-variant">' + item.variant_title + '</p>';
      }
      html += '<p class="cart-item-price">' + fmtMoney(item.price) + ' ex VAT</p>';
      html += '<div class="cart-item-qty">';
      html += '<button class="cart-qty-btn" onclick="changeCartQty(\'' + safeKey + '\', -1)">−</button>';
      html += '<span class="cart-qty-num">' + item.quantity + '</span>';
      html += '<button class="cart-qty-btn" onclick="changeCartQty(\'' + safeKey + '\', 1)">+</button>';
      html += '</div></div>';
      html += '<button class="cart-item-remove" onclick="removeCartItem(\'' + safeKey + '\')" title="Remove">×</button>';
      html += '</div>';
    });

    itemsEl.innerHTML = html;

    var sub = cart.total_price;           // ex-VAT (Shopify price)
    var vat = Math.round(sub * VAT_RATE); // 20% VAT
    var shipFree = sub >= FREE_SHIP_THRESHOLD;
    var ship = shipFree ? 0 : SHIP_COST;
    var total = sub + vat + ship;         // inc-VAT total

    if (subtotalEl) subtotalEl.textContent = fmtMoney(sub);
    var vatEl = getEl('es-cart-vat');
    if (vatEl) vatEl.textContent = fmtMoney(vat);
    if (shipEl) shipEl.textContent = shipFree ? 'Free' : fmtMoney(SHIP_COST);
    if (totalEl) totalEl.textContent = fmtMoney(total);

    var pct = Math.min(100, Math.round(sub / FREE_SHIP_THRESHOLD * 100));
    if (fillEl) fillEl.style.width = pct + '%';
    if (labelEl) {
      labelEl.textContent = shipFree
        ? '✓ Free UK delivery unlocked'
        : 'Spend £' + ((FREE_SHIP_THRESHOLD - sub) / 100).toFixed(0) + ' more for free delivery';
    }
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('es-cart-badge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  /* ---- ATC button on product cards ------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.es-add-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    addToCart(variantId, 1, function () {
      btn.disabled = false;
    });
  });

  /* ---- Main product page ATC ------------------------------ */
  window.esAddToCart = function (variantId, qty) {
    var atcBtn = document.getElementById('es-atc-btn');
    var confirmEl = document.getElementById('es-atc-confirm');
    if (atcBtn) atcBtn.style.display = 'none';
    if (confirmEl) confirmEl.style.display = 'block';

    addToCart(variantId, qty || 1, function () {
      setTimeout(function () {
        if (atcBtn) atcBtn.style.display = 'block';
        if (confirmEl) confirmEl.style.display = 'none';
      }, 2000);
    });
  };

  /* ---- Buy now -------------------------------------------- */
  window.esBuyNow = function (variantId, qty) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function () { window.location.href = '/checkout'; });
  };

  /* ---- Product gallery thumbs ----------------------------- */
  function esGallerySelect(gallery, thumb) {
    gallery.querySelectorAll('.es-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    var mainImg = gallery.querySelector('#es-main-img');
    var src  = thumb.dataset.src  || (thumb.querySelector('img') && thumb.querySelector('img').src);
    var full = thumb.dataset.full || src;
    if (mainImg && src) { mainImg.src = src; if (full) mainImg.dataset.full = full; }
  }

  /* ---- Lightbox ------------------------------------------- */
  var lbImages = [];
  var lbIndex  = 0;

  function lbCollectImages() {
    var thumbs = document.querySelectorAll('.es-thumb');
    lbImages = Array.from(thumbs).map(function (t) {
      return { full: t.dataset.full || t.dataset.src, src: t.dataset.src };
    });
    if (!lbImages.length) {
      var main = document.getElementById('es-main-img');
      if (main) lbImages = [{ full: main.dataset.full || main.src, src: main.src }];
    }
  }

  function lbShow(index) {
    var lbImg  = document.getElementById('es-lightbox-img');
    var cur    = document.getElementById('es-lb-cur');
    var tot    = document.getElementById('es-lb-tot');
    var wrap   = document.querySelector('.es-lb-img-wrap');
    if (!lbImg) return;
    lbIndex   = (index + lbImages.length) % lbImages.length;
    lbImg.src = lbImages[lbIndex].full || lbImages[lbIndex].src;
    if (cur) cur.textContent = lbIndex + 1;
    if (tot) tot.textContent = lbImages.length;
    if (wrap) { wrap.classList.remove('zoomed'); wrap.scrollTop = 0; wrap.scrollLeft = 0; }
    var prev = document.querySelector('.es-lb-prev');
    var next = document.querySelector('.es-lb-next');
    var show = lbImages.length > 1;
    if (prev) prev.style.display = show ? '' : 'none';
    if (next) next.style.display = show ? '' : 'none';
  }

  window.esOpenLightbox = function () {
    var mainImg = document.getElementById('es-main-img');
    var lb      = document.getElementById('es-lightbox');
    if (!lb) return;
    lbCollectImages();
    var activeThumb = document.querySelector('.es-thumb.active');
    var startIdx = 0;
    if (activeThumb) {
      var thumbs = Array.from(document.querySelectorAll('.es-thumb'));
      startIdx = thumbs.indexOf(activeThumb);
    }
    lbShow(startIdx);
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.esCloseLightbox = function () {
    var lb   = document.getElementById('es-lightbox');
    var wrap = document.querySelector('.es-lb-img-wrap');
    if (lb)   lb.classList.remove('open');
    if (wrap) wrap.classList.remove('zoomed');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    var lb = document.getElementById('es-lightbox');
    if (!lb || !lb.classList.contains('open')) return;
    if (e.key === 'Escape')      { window.esCloseLightbox(); }
    else if (e.key === 'ArrowRight') { lbShow(lbIndex + 1); }
    else if (e.key === 'ArrowLeft')  { lbShow(lbIndex - 1); }
  });

  document.addEventListener('click', function (e) {
    var lb = document.getElementById('es-lightbox');
    if (!lb || !lb.classList.contains('open')) return;

    if (e.target.closest('.es-lightbox-close')) { window.esCloseLightbox(); return; }
    if (e.target.closest('.es-lb-prev')) { lbShow(lbIndex - 1); return; }
    if (e.target.closest('.es-lb-next')) { lbShow(lbIndex + 1); return; }

    var wrap = e.target.closest('.es-lb-img-wrap');
    if (wrap) {
      wrap.classList.toggle('zoomed');
      if (wrap.classList.contains('zoomed')) {
        wrap.scrollTop  = (wrap.scrollHeight - wrap.clientHeight) / 2;
        wrap.scrollLeft = (wrap.scrollWidth  - wrap.clientWidth)  / 2;
      }
      return;
    }

    if (e.target === lb) { window.esCloseLightbox(); }
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.es-thumb');
    if (thumb) {
      var gallery = thumb.closest('.es-gallery');
      if (gallery) esGallerySelect(gallery, thumb);
      return;
    }

    var btn = e.target.closest('.es-gallery-prev, .es-gallery-next');
    if (!btn) return;
    var gallery = btn.closest('.es-gallery');
    if (!gallery) return;
    var thumbs = Array.from(gallery.querySelectorAll('.es-thumb'));
    if (!thumbs.length) return;
    var activeIdx = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
    if (activeIdx === -1) activeIdx = 0;
    var next = btn.classList.contains('es-gallery-next')
      ? (activeIdx + 1) % thumbs.length
      : (activeIdx - 1 + thumbs.length) % thumbs.length;
    esGallerySelect(gallery, thumbs[next]);
  });

  /* ---- Quantity stepper (product page) -------------------- */
  var esQty = 1;

  window.changeQty = function (delta) {
    esQty = Math.max(1, esQty + delta);
    var display = document.getElementById('es-qty-display');
    if (display) display.textContent = esQty;
  };

  window.getQty = function () { return esQty; };

  /* ---- Accordion ------------------------------------------ */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion-trigger');
    if (!trigger) return;
    var content = trigger.nextElementSibling;
    var isOpen = content && content.classList.contains('open');

    document.querySelectorAll('.accordion-content').forEach(function (c) { c.classList.remove('open'); });
    document.querySelectorAll('.accordion-trigger').forEach(function (t) { t.classList.remove('open'); });

    if (!isOpen && content) {
      content.classList.add('open');
      trigger.classList.add('open');
    }
  });

  /* ---- Tile depth visualiser ------------------------------ */
  (function () {
    var vT = {
      5:  { deg: 4,  spread: .07, quality: 'Precise',    use: 'Precision redirect' },
      10: { deg: 8,  spread: .14, quality: 'Directional',use: 'Light strip effects' },
      20: { deg: 12, spread: .21, quality: 'Versatile',  use: 'Direct source' },
      25: { deg: 50, spread: .87, quality: 'Wide spread', use: 'Fill and ambient' }
    };
    var vC = 5, vCol = 'gold';

    function vSetTile(mm) {
      vC = mm;
      document.querySelectorAll('.tile-btn-v').forEach(function (b) { b.classList.remove('active'); });
      var btn = document.getElementById('vtile-' + mm);
      if (btn) btn.classList.add('active');
      vDraw(); vInfo();
    }

    function vSetColor(c) {
      vCol = c;
      document.querySelectorAll('.col-btn-v').forEach(function (b) { b.classList.remove('active'); });
      var btn = document.getElementById('vcol-' + c);
      if (btn) btn.classList.add('active');
      vDraw();
    }

    function vInfo() {
      var t = vT[vC];
      var mm = document.getElementById('vinf-mm'); if (mm) mm.textContent = vC + 'mm';
      var deg = document.getElementById('vinf-deg'); if (deg) deg.textContent = t.deg + '°';
      var qual = document.getElementById('vinf-qual'); if (qual) qual.textContent = t.quality;
      var use = document.getElementById('vinf-use'); if (use) use.textContent = t.use;
    }

    function vDraw() {
      var cv = document.getElementById('vcanvas');
      if (!cv) return;
      var W = cv.offsetWidth || 680;
      cv.width = W; cv.height = 280;
      var ctx = cv.getContext('2d'), H = 280, t = vT[vC], sp = t.spread, isG = vCol === 'gold';
      ctx.fillStyle = '#f0ede8'; ctx.fillRect(0, 0, W, H);
      var refX = Math.round(W * .14), refY = Math.round(H * .5), refH = 80, lsX = Math.round(W * .04);
      ctx.fillStyle = isG ? 'rgba(255,210,80,.35)' : 'rgba(200,215,230,.35)';
      ctx.fillRect(lsX, refY - 5, refX - lsX, 10);
      ctx.fillStyle = isG ? '#c8a96e' : '#b0b0b0';
      ctx.fillRect(refX, refY - refH / 2, 10, refH);
      var bsX = refX + 10, bLen = W - bsX - 35, nR = 28, lB = isG ? 'rgba(255,195,70,' : 'rgba(210,225,240,';
      for (var i = 0; i < nR; i++) {
        var tn = i / (nR - 1), ang = (tn - .5) * sp * Math.PI;
        var ex = bsX + Math.cos(ang) * bLen, ey = refY + Math.sin(ang) * bLen;
        var al = Math.max(0, .22 - Math.abs(tn - .5) * .38);
        ctx.strokeStyle = lB + al + ')'; ctx.lineWidth = sp < .3 ? 2.5 : 1.5;
        ctx.beginPath(); ctx.moveTo(bsX, refY); ctx.lineTo(ex, ey); ctx.stroke();
      }
      var hA = sp * Math.PI / 2;
      var tX = bsX + Math.cos(-hA) * bLen, tY = refY + Math.sin(-hA) * bLen;
      var bX = bsX + Math.cos(hA) * bLen, bY = refY + Math.sin(hA) * bLen;
      ctx.fillStyle = lB + '.1)'; ctx.beginPath();
      ctx.moveTo(bsX, refY); ctx.lineTo(tX, tY); ctx.lineTo(bX, bY);
      ctx.closePath(); ctx.fill();
      var hitX = W - 32, hitH = Math.abs(bY - tY), hitTop = refY - hitH / 2;
      ctx.fillStyle = '#d8d4cc'; ctx.fillRect(hitX, 0, 32, H);
      var grd = ctx.createLinearGradient(0, hitTop, 0, hitTop + hitH);
      grd.addColorStop(0, lB + '0)'); grd.addColorStop(.5, lB + '.6)'); grd.addColorStop(1, lB + '0)');
      ctx.fillStyle = grd; ctx.fillRect(hitX, hitTop, 32, hitH);
      ctx.fillStyle = 'rgba(0,0,0,.18)'; ctx.font = '11px DM Sans,sans-serif'; ctx.textAlign = 'center';
      ctx.fillText('light source', lsX + (refX - lsX) / 2, refY - 12);
      ctx.fillText('reflector', refX + 5, refY - refH / 2 - 8);
      ctx.fillText('subject', hitX + 16, hitTop > 20 ? hitTop - 8 : hitTop + hitH + 16);
    }

    window.vSetTile = vSetTile;
    window.vSetColor = vSetColor;

    function vInit() { vDraw(); vInfo(); }
    if (document.readyState === 'complete') { setTimeout(vInit, 100); }
    else { window.addEventListener('load', function () { setTimeout(vInit, 100); }); }
    window.addEventListener('resize', vDraw);
  })();

  /* ---- Initial cart count on load ------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(function (cart) { if (cart) updateCartBadge(cart.item_count); });
  });

})();
